import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, PawPrint, ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/store/Logo";
import { SurveyForm } from "@/components/closefriends/SurveyForm";

export default function CloseFriends() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    document.title = "Encuesta Lenda – Close Friends | The Pet Shopping Co";
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  const submit = async (payload) => {
    await api.post("/close-friends", payload);
    setDone(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen paw-bg">
      <div className="max-w-2xl mx-auto px-4 pt-6 pb-16">
        <div className="flex items-center justify-between mb-6">
          <Link to="/" data-testid="cf-logo-home" aria-label="Ir a la tienda"><Logo size={56} /></Link>
          <Link to="/tienda" data-testid="cf-header-store" className="inline-flex items-center gap-1.5 px-4 h-10 rounded-xl bg-white border border-[#E3E7E2] text-sm font-semibold text-charcoal hover:bg-peach/50 active:scale-95 transition-transform">
            <ShoppingBag className="w-4 h-4 text-coral" /> Ir a la tienda
          </Link>
        </div>
        {done ? (
          <div data-testid="cf-thanks" className="rounded-3xl bg-white border border-[#E3E7E2] p-8 text-center card-shadow">
            <span className="mx-auto grid place-items-center w-16 h-16 rounded-full bg-peach text-coral mb-4"><Heart className="w-8 h-8 fill-coral" /></span>
            <h1 className="font-display text-3xl sm:text-4xl font-bold text-charcoal mb-3">¡Muchas gracias!</h1>
            <p className="text-muted-moss">Recibimos tu información. Gracias por ser parte de nuestros Close Friends y ayudarnos a crear Lenda para tus peluditos.</p>
            <Link to="/tienda" data-testid="cf-thanks-store" className="mt-6 inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 h-14 rounded-2xl bg-coral text-white font-bold hover:bg-coral-dark active:scale-[0.98] transition-transform">
              <ShoppingBag className="w-5 h-5" /> Ver más cosas en la tienda
            </Link>
          </div>
        ) : (
          <>
            <header className="mb-8">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-teal/40 text-xs font-bold uppercase tracking-wider text-charcoal mb-3">
                <PawPrint className="w-3.5 h-3.5" /> Close Friends
              </span>
              <h1 data-testid="cf-title" className="font-display text-4xl sm:text-5xl font-bold text-charcoal leading-tight mb-3">Encuesta Lenda</h1>
              <p className="text-base text-muted-moss">Cuéntanos qué come tu perro o gato. Te toma 3 minutos y nos ayuda a crear el mejor alimento para ellos.</p>
            </header>
            <SurveyForm onSubmit={submit} />
          </>
        )}
      </div>
    </div>
  );
}
